import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-content-title',
    templateUrl: './content-title.component.html',
    styleUrls: ['./content-title.component.scss'],
    standalone: false
})
export class ContentTitleComponent {
  @Input() title: string;
}
